import React from "react";
import "./Login.css"
import { Auth } from "@supabase/auth-ui-react";
import { ThemeSupa } from "@supabase/auth-ui-shared";
import { supabase } from "../../services/db";

const Login = () => {
  return (
    <div className="loginContainer whiteFont">
      <div>
        <h1>Recipeat</h1>
        <p>
          Never lose track of your recipes again. Recipeat is a hub for all your
          favourite recipes.
        </p>
        <Auth
          supabaseClient={supabase()}
          appearance={{ theme: ThemeSupa }}
          providers={["google"]}
        />
      </div>
    </div>
  );
};

export default Login;
